import { withLoadedModifiedDate, getWriteErrorMessage, shouldReloadAfterWriteError } from '@1823-partners/core';
import { formatCREData } from './creUtils';

// The request carries the loaded row's MODIFIED_DATE byte-for-byte (or null
// for a never-saved key) and excludes MODIFIED_BY, which the writer stamps.
// The formatted row can come from the grid, a form, or an uploaded file; the
// trusted token always comes from the loaded row, never from that upload.
export const creWriteRow = (row, loadedRow = row) =>
  withLoadedModifiedDate(formatCREData(row), loadedRow);

export const savedCREToken = (row, modifiedDate) => ({
  ...row,
  MODIFIED_DATE: modifiedDate,
  _isUploadedNew: false,
});

export const creWriteError = (error, fallback) => ({
  message: getWriteErrorMessage(error, fallback),
  reload: shouldReloadAfterWriteError(error),
});

// A temporary grid CUSIP is not a valid business key. The user must open its
// form and choose a real CUSIP; otherwise an INSERT would make new_row_* a
// permanent Snowflake key that cannot be renamed.
export const hasTemporaryCusip = (rows) =>
  rows.some((row) => String(row.CUSIP || '').startsWith('new_row_'));
